import { useRef, useEffect } from 'react';
import styled from '@emotion/styled';
import { t } from 'services/translation';
import { Theme } from 'ui_system/theme';
import { isActionKey } from 'ui_system/utilities/KeyboardHelpers';

const ErrorModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const ErrorRefreshButton = styled.button`
  height: 44px;
  width: 85px;
  font-size: 16px;
  line-height: 20px;
  color: white;
  background-color: ${Theme.colors.blue};
  border: 1px solid ${Theme.colors.blue};
  border-radius: 4px;
  margin: 24px auto 32px;
  padding: 12px 32px;
  @media (max-width: ${Theme.mobile.phoneWidth}px) {
    font-size: 15px;
    line-height: 18px;
  }
`;

const ErrorHeading = styled.h1`
  color: #333333;
  font-size: 18px;
  line-height: 22px;
  margin: 32px 0 16px 0;
  text-align: center;
  @media (max-width: ${Theme.mobile.phoneWidth}px) {
    font-size: 17px;
    line-height: 17px;
  }
`;

const ErrorSubText = styled.p`
  color: #333333;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  @media (max-width: ${Theme.mobile.phoneWidth}px) {
    font-size: 13px;
    line-height: 17px;
  }
`;

const ErrorModal = (): JSX.Element => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (buttonRef.current !== null) {
      buttonRef.current.focus();
    }
  }, []);

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <ErrorModalContainer>
      <ErrorHeading>{t('OOPS')}, something went wrong!</ErrorHeading>
      <ErrorSubText>{t('PLEASE_TRY_SUBMITTING_AGAIN')}.</ErrorSubText>
      <ErrorRefreshButton
        type="button"
        onClick={handleReload}
        onKeyDown={(e) => (isActionKey(e.key) ? handleReload : null)}
        ref={buttonRef}
      >
        {t('OK')}
      </ErrorRefreshButton>
    </ErrorModalContainer>
  );
};

export default ErrorModal;
